import { render, staticRenderFns } from "./ObiRuleCard.vue?vue&type=template&id=d562d56c&scoped=true&"
import script from "./ObiRuleCard.vue?vue&type=script&lang=js&"
export * from "./ObiRuleCard.vue?vue&type=script&lang=js&"
import style0 from "./ObiRuleCard.vue?vue&type=style&index=0&id=d562d56c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d562d56c",
  null
  
)

export default component.exports